import Contact from "./FrontPage/FrontPage";
import Home from "./Home/Home";
import Log from "./Log/Log"
import OpenSec from "./OpenSec/OpenSec"
import Login from "./Login/Login"
import SecNew from "./SecNew/SecNew"
import Join from "./Join/Join";

import { BrowserRouter as Router, Route, Routes, useLocation, useParams } from 'react-router-dom';
import NewPage from "./NewPage/NewPage";
import TopicsNews from "./TopicsNews/TopicsNews";
import OpenFront from "./OpenFront/OpenFront";





function App() {
  
  const location = useLocation();


  let { id } = useParams();

  return (

    <div className="App">
      
    <Routes location={location} key={location.pathname}>
          <Route path="/" element={<><Home /></> } />
          <Route path="/join" element={<>  <Join /></> } />
          <Route path="/login" element={<><Login /></> } />
        <Route path="/log/:id" element={<><Log /></>} />
        <Route path="/newpage/:id" element={<><NewPage /></>} />
        <Route path="/section/:id" element={<><TopicsNews /></>} />
        <Route path="/secnew/:id" element={<><SecNew /></>} />
        <Route path="/open/:id" element={<><OpenFront /></>} />
         <Route path="/opensec" element={<><OpenSec /></>} />
      </Routes>
 
    
    </div>
  );
}

export default App;
